import { cn } from "@/lib/utils";

export function Logo({
  size = "md",
  showTagline = false,
  className,
}: {
  size?: "sm" | "md" | "lg" | "xl";
  showTagline?: boolean;
  className?: string;
}) {
  const sizes = {
    sm: "w-32",
    md: "w-44",
    lg: "w-52",
    xl: "w-64",
  };

  return (
    <div className={cn("flex flex-col items-center", className)}>
      <img
        src="/nestd_logo_transparent.png"
        alt="Nestd"
        className={cn("h-auto object-contain", sizes[size])}
      />
      {showTagline && (
        <span className="text-[10px] uppercase tracking-[0.2em] text-muted mt-1">
          OS for student accommodation
        </span>
      )}
    </div>
  );
}
